import { Component, Element, Prop, Host, h } from '@stencil/core';
import { Color } from '../../../interface';
import { createColorClasses } from '../../../utils/theme';

@Component({
  tag: 'lar-badge',
  styleUrl: 'badge.scss',
  shadow: true
})

export class Badge {
  @Element() el!: HTMLElement;
  @Prop() color?: Color;

  render() {
    return (
      <Host class={{ ...createColorClasses(this.color) }}>
        <slot></slot>
      </Host>
    );
  }
}
